// import React, { useEffect, useState } from "react";
// import ProfileBackground from "../../../../../../assets/images/profile-background.png";
// import ProfileImage from "../../../../../../assets/images/profile-image.png";
// import { getApi } from "../../../../../../api/api_instance";
// import { API_URLS } from "../../../../../../api/apiUrls";
// import { useSelector } from "react-redux";
// import { ReactComponent as CarbonFootprint } from "../../../../../../assets/svgs/dashboardn.svg";
// import { ReactComponent as WaterFootprint } from "../../../../../../assets/svgs/waterfootprints.svg";
// import Item from "antd/es/list/Item";

// const countries = [
//   "United States",
//   "Canada",
//   "United Kingdom",
//   "India",
//   "Germany",
//   "France",
//   "Australia",
// ];

// const MyProfile = () => {
//   const token = useSelector((state) => state.auth.authToken);
//   const user = useSelector((state) => state.auth.user);

//   const [basicInformation, setBasicInformation] = useState({
//     name: "",
//     username: "",
//     userId: "",
//     location: "",
//     contactNumber_1: "",
//     contactNumber_2: "",
//     emailId_1: "",
//     emailId_2: "",
//     primaryContactNumber: "",
//     primaryEmailId: "",
//     description: "",
//   });

//   const handleChange = (e) => {
//     setBasicInformation({
//       ...basicInformation,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handlePrimarySelection = (option) => {
//     if (option === "contact_1") {
//       setBasicInformation({
//         ...basicInformation,
//         primaryContactNumber: basicInformation.contactNumber_1,
//         primaryEmailId: basicInformation.emailId_1,
//       });
//     } else if (option === "contact_2") {
//       setBasicInformation({
//         ...basicInformation,
//         primaryContactNumber: basicInformation.contactNumber_2,
//         primaryEmailId: basicInformation.emailId_2,
//       });
//     }
//   };

//   const fetchDetails = async () => {
//     try {
//       const response = await getApi({
//         //apiUrl: API_URLS.PROFILE_DETAILS(user_id),
//         apiUrl: API_URLS.PROFILE_DETAILS,
//         token:
//           "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2N2QxMmRhMDM5N2YwMDI2NjU2M2E2YjYiLCJlbWFpbCI6Im5hd2FuZWV0QG9mZnNldGdvLmVhcnRoIiwibmFtZSI6Ik9mZnNldEdvIiwib2Zmc2V0X2lkIjoiNjc3Njg5NjNkZDJkMWE1MjkwYWE0NDRlIiwiaWF0IjoxNzQ2NTE5NTc2LCJleHAiOjE3NDkxMTE1NzZ9.HBX2ACLtvxg9BJi1xv8fCq_zX3H-SxES3MjyBMVX1Ng",
//       });
//       if (response.success) {
//         console.log(response.data);
//         const data = response.data;
//         setBasicInformation({
//           name: data.name,
//           username: data.email,
//           userId: data.user_id,
//           location: Item.location,
//           contactNumber_1: "",
//           contactNumber_2: "",
//           emailId_1: data.email,
//           emailId_2: "",
//           primaryContactNumber: "",
//           primaryEmailId: "",
//           description: "",
//         });
//       }
//     } catch (error) {
//       console.log("Unable to get user details", error);
//     }
//   };

//   useEffect(() => {
//     if (token) {
//       fetchDetails();
//     }
//   }, [token]);

//   return (
//     <div style={{ backgroundColor: "#fff" }} className="my-2">
//       <div className="px-4">
//         <div
//           style={{
//             backgroundImage: `url(${ProfileBackground})`,
//             backgroundSize: "cover",
//             backgroundPosition: "center",
//           }}
//           className="h-52 px-4 relative rounded-lg"
//         >
//           <img
//             src={ProfileImage}
//             alt="Profile"
//             className="absolute bottom-[-50px] left-6 w-24 h-24 object-cover rounded-full border-4 border-white"
//           />
//         </div>
//       </div>
//       <div className="px-36 ">
//         <p className=" text-2xl">{basicInformation.name}</p>
//         <p className="mt-[-25px] font-light">{basicInformation.userId}</p>
//       </div>
//       <div
//         style={{
//           borderTop: "1px solid #3BA2B959",
//           borderRadius: "10px",
//           paddingTop: "20px",
//           boxShadow: "0px 0px 16px 0px #3BA2B91F",
//           backgroundColor: "#fff",
//         }}
//       >
//         <div className="flex px-10 gap-4 pb-4">
//           <div className="bg-[#06513D] rounded-md">
//             <div className="flex px-2 items-center">
//               {/* <div className="bg-white p-1 rounded-md"> */}
//               <CarbonFootprint />
//               {/* </div> */}
//               <p className="text-white font-bold text-sm px-3 pt-3">
//                 Total Carbon Footprint
//               </p>
//               <div className="bg-white text-[#06513D] rounded-md ">
//                 <p className="px-4 text-xl my-auto py-1 font-semibold">
//                   5378 <span className="text-sm font-light">MT CO2e</span>
//                 </p>
//               </div>
//             </div>
//           </div>
//           <div className="bg-[#06513D] rounded-md">
//             <div className="flex px-2 items-center">
//               {/* <div className="bg-white p-1 rounded-md"> */}
//               <WaterFootprint />
//               {/* </div> */}
//               <p className="text-white font-bold text-sm px-3 pt-3">
//                 Total Water Footprint
//               </p>
//               <div className="bg-white text-[#06513D] rounded-md ">
//                 <p className="px-4 text-xl my-auto py-1 font-semibold">
//                   4582 <span className="text-sm font-light">MT CO2e</span>
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div
//           style={{
//             borderTop: "1px solid #3BA2B959",
//             borderRadius: "10px",
//             paddingTop: "20px",
//             boxShadow: "0px 0px 16px 0px #3BA2B91F",
//             backgroundColor: "#fff",
//           }}
//         >
//           <div className="px-10">
//             <h4 className="text-xl text-[#06513D]">Basic Information</h4>

//             <div className="flex justify-between mb-6">
//               {/* Left Section */}
//               <div>
//                 <div className="mb-6">
//                   <label className="block font-semibold text-gray-500">
//                     Name
//                   </label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={basicInformation.name}
//                     onChange={handleChange}
//                     className="w-80 p-2 border-b focus:outline-none"
//                   />
//                 </div>

//                 <div className="mb-6">
//                   <label className="block font-semibold text-gray-500">
//                     User ID
//                   </label>
//                   <input
//                     type="text"
//                     name="userId"
//                     value={basicInformation.userId}
//                     onChange={handleChange}
//                     className="w-80 p-2 border-b focus:outline-none"
//                   />
//                 </div>
//               </div>

//               {/* Right Section */}
//               <div>
//                 <div className="mb-6">
//                   <label className="block font-semibold text-gray-500">
//                     Username
//                   </label>
//                   <input
//                     type="text"
//                     name="username"
//                     value={basicInformation.username}
//                     onChange={handleChange}
//                     className="w-80 p-2 border-b focus:outline-none"
//                   />
//                 </div>

//                 <div className="mb-6">
//                   <label className="block font-semibold text-gray-500">
//                     Location
//                   </label>
//                   <select
//                     name="location"
//                     value={basicInformation.location}
//                     onChange={handleChange}
//                     className="w-80 p-2 border-b focus:outline-none"
//                   >
//                     <option value="">Select a country</option>
//                     {countries.map((country, index) => (
//                       <option key={index} value={country}>
//                         {country}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Contact Details */}
//           <div className="px-10">
//             <h4 className="text-xl text-[#06513D]">Contact Details</h4>

//             <div>
//               {/* Contact Details 1 */}
//               <div className="flex justify-between gap-5 mb-6">
//                 <div className="mb-6">
//                   <label className="block font-semibold text-gray-500">
//                     1. Contact Number
//                   </label>
//                   <input
//                     type="text"
//                     name="contactNumber_1"
//                     value={basicInformation.contactNumber_1}
//                     onChange={handleChange}
//                     className="w-64 p-2 border-b focus:outline-none"
//                   />
//                 </div>

//                 <div className="mb-6">
//                   <label className="block font-semibold text-gray-500">
//                     Email ID
//                   </label>
//                   <input
//                     type="text"
//                     name="emailId_1"
//                     value={basicInformation.emailId_1}
//                     onChange={handleChange}
//                     className="w-64 p-2 border-b focus:outline-none"
//                   />
//                 </div>

//                 {/* Primary Radio Button */}
//                 <div>
//                   <input
//                     type="radio"
//                     id="primary_1"
//                     name="primaryContact"
//                     onChange={() => handlePrimarySelection("contact_1")}
//                     checked={
//                       basicInformation.primaryContactNumber ===
//                       basicInformation.contactNumber_1
//                     }
//                   />
//                   <label htmlFor="primary_1" className="ml-2 text-gray-500">
//                     Make it Primary
//                   </label>
//                 </div>
//               </div>

//               {/* Contact Details 2 */}
//               <div className="flex justify-between gap-5 mb-6">
//                 <div className="mb-6">
//                   <label className="block font-semibold text-gray-500">
//                     2. Contact Number
//                   </label>
//                   <input
//                     type="text"
//                     name="contactNumber_2"
//                     value={basicInformation.contactNumber_2}
//                     onChange={handleChange}
//                     className="w-64 p-2 border-b focus:outline-none"
//                   />
//                 </div>

//                 <div className="mb-6">
//                   <label className="block font-semibold text-gray-500">
//                     Email ID
//                   </label>
//                   <input
//                     type="text"
//                     name="emailId_2"
//                     value={basicInformation.emailId_2}
//                     onChange={handleChange}
//                     className="w-64 p-2 border-b focus:outline-none"
//                   />
//                 </div>

//                 {/* Primary Radio Button */}
//                 <div>
//                   <input
//                     type="radio"
//                     id="primary_2"
//                     name="primaryContact"
//                     className="text-[#06513D]"
//                     onChange={() => handlePrimarySelection("contact_2")}
//                     checked={
//                       basicInformation.primaryContactNumber ===
//                       basicInformation.contactNumber_2
//                     }
//                   />
//                   <label htmlFor="primary_2" className="ml-2 text-gray-500">
//                     Make it Primary
//                   </label>
//                 </div>
//               </div>
//               <div className="py-3">
//                 <label className="block font-semibold text-gray-500 pb-4">
//                   Description
//                 </label>
//                 <textarea
//                   type="text"
//                   name="name"
//                   value={basicInformation.description}
//                   onChange={handleChange}
//                   className="w-full h-24 p-2 border rounded-lg border-black focus:outline-none"
//                 />
//               </div>
//               <div className="w-full bg-[#C8D9D4] text-[#06513D] rounded-md">
//                 <p className="text-center py-2 font-semibold">
//                   {" "}
//                   + Add Contact Details
//                 </p>
//               </div>
//             </div>
//             {/* Display Selected Primary Contact */}
//             {basicInformation.primaryContactNumber && (
//               <p className="text-green-600 font-semibold">
//                 Primary Contact: {basicInformation.primaryContactNumber} (
//                 {basicInformation.primaryEmailId})
//               </p>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MyProfile;

import React, { useState, useEffect, useRef } from "react";
import { Plus, Camera, Trash2, Upload } from "lucide-react";
import { deleteApi } from "../../../../../../api/api_instance";
import { API_URLS } from "../../../../../../api/apiUrls";

import ProfileBackground from "../../../../../../assets/images/profile-background.png";
import ProfileImage from "../../../../../../assets/images/profile-image.png";
import Avatar from "../../../../../../assets/svgs/avatar_green.svg";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as CarbonFootprint } from "../../../../../../assets/svgs/dashboardn.svg";
import { ReactComponent as WaterFootprint } from "../../../../../../assets/svgs/waterfootprints.svg";
import {
  fetchProfileData,
  updateProfileData,
} from "../../../../../../redux/ProfileSlice/profileSlice";
import { updateOrganizationName } from "../../../../../../redux/auth/authSlice";
import coverImage from "../../../../../../assets/svgs/Cover-Image.svg";
import {
  appendJsonSection,
  appendProfileFiles,
  buildBasicInfoPayload,
  buildContactsFromMyProfile,
  getProfileImageUrl,
} from "../profileFormUtils";
import PopupCard from "../../../../../Auth/PopupCard";
const countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Côte d'Ivoire",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo (Congo-Brazzaville)",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czechia (Czech Republic)",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Holy See",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine State",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export default function MyProfile() {
  const dispatch = useDispatch();
  const { user, organisationLogin } = useSelector((state) => state.auth);
  const { profileData, profileUpdateLoading } = useSelector(
    (state) => state.profile,
  );
  const profile = profileData?.data || profileData;

  const organizationName =
    user?.organizationName || profile?.organization?.name || "";

  const profileImageInputRef = useRef(null);
  const bannerImageInputRef = useRef(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successPopupMessage, setSuccessPopupMessage] = useState("");
  const [saving, setSaving] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState("");
  const [loginEmail, setLoginEmail] = useState("");
  const [profileImagePreview, setProfileImagePreview] = useState("");
  const [bannerImagePreview, setBannerImagePreview] = useState("");
  const [pendingFiles, setPendingFiles] = useState({
    profileImageFile: null,
    bannerImageFile: null,
  });

  const [isEditMode, setIsEditMode] = useState(false);
  const [role, setRole] = useState();
  const [basicInformation, setBasicInformation] = useState({
    name: "",
    username: "",
    userId: "",
    location: "",
    contactNumber_1: "",
    contactNumber_2: "",
    emailId_1: "",
    emailId_2: "",
    primaryContactNumber: "",
    primaryEmailId: "",
    description: "",
  });

  const handleChange = (e) => {
    setBasicInformation({
      ...basicInformation,
      [e.target.name]: e.target.value,
    });
  };

  const handlePrimarySelection = (option) => {
    if (option === "contact_1") {
      setBasicInformation({
        ...basicInformation,
        primaryContactNumber: basicInformation.contactNumber_1,
        primaryEmailId: basicInformation.emailId_1,
      });
    } else if (option === "contact_2") {
      setBasicInformation({
        ...basicInformation,
        primaryContactNumber: basicInformation.contactNumber_2,
        primaryEmailId: basicInformation.emailId_2,
      });
    }
  };
  useEffect(() => {
    if (!showSuccessPopup) return;

    const timer = setTimeout(() => {
      setShowSuccessPopup(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [showSuccessPopup]);
  useEffect(() => {
    if (!profile?._id) {
      return;
    }

    setLoginEmail(profile.email || "");

    const contacts = profile.contacts || [];
    const firstContact = contacts[0] || {};
    const secondContact = contacts[1] || {};
    const primaryContact =
      contacts.find((contact) => contact?.isPrimary) || firstContact;
    const roles = organisationLogin ? "Admin" : "";
    setRole(roles);
    setBasicInformation({
      name: profile.name || "",
      username: profile.username || "",
      userId: profile.userId || profile.user_id || "",
      role: "admin",
      location: profile.location || "",
      contactNumber_1: firstContact.contactNumber || "",
      contactNumber_2: secondContact.contactNumber || "",
      emailId_1: firstContact.email || "",
      emailId_2: secondContact.email || "",
      primaryContactNumber: primaryContact.contactNumber || "",
      primaryEmailId: primaryContact.email || "",
      description: profile.description || "",
    });
  }, [profile, organisationLogin]);

  useEffect(() => {
    const orgName = profile?.organization?.name?.trim();
    if (orgName && orgName !== user?.organizationName) {
      dispatch(updateOrganizationName(orgName));
    }
  }, [profile?.organization?.name, user?.organizationName, dispatch]);

  const bannerSrc =
    bannerImagePreview ||
    getProfileImageUrl(profile?.bannerImage?.filePath) ||
    coverImage;

  const avatarSrc =
    profileImagePreview ||
    getProfileImageUrl(profile?.profileImage?.filePath) ||
    Avatar;

  const handleImageSelect = (type, file) => {
    if (!file) return;
    const preview = URL.createObjectURL(file);
    if (type === "profile") {
      setProfileImagePreview(preview);
      setPendingFiles((prev) => ({ ...prev, profileImageFile: file }));
    } else {
      setBannerImagePreview(preview);
      setPendingFiles((prev) => ({ ...prev, bannerImageFile: file }));
    }
  };

  const handleDeleteBanner = async () => {
    if (bannerImagePreview) {
      setBannerImagePreview("");
      setPendingFiles((prev) => ({ ...prev, bannerImageFile: null }));
      return;
    }
    if (profile?.bannerImage?.filePath) {
      try {
        setSaving(true);
        const response = await deleteApi({
          apiUrl: API_URLS.DELETE_CLIENT_PROFILE_IMAGE("bannerImage"),
        });
        if (response?.success) {
          setSuccessPopupMessage("Cover image deleted successfully");
          setShowSuccessPopup(true);
          dispatch(fetchProfileData(user._id));
        } else {
          setErrorPopupMessage(
            response?.message || "Failed to delete cover image",
          );
          setShowErrorPopup(true);
        }
      } catch (error) {
        setErrorPopupMessage(error?.message || "Failed to delete cover image");
        setShowErrorPopup(true);
      } finally {
        setSaving(false);
      }
    }
  };

  const handleDeleteProfile = async () => {
    if (profileImagePreview) {
      setProfileImagePreview("");
      setPendingFiles((prev) => ({ ...prev, profileImageFile: null }));
      return;
    }
    if (profile?.profileImage?.filePath) {
      try {
        setSaving(true);
        const response = await deleteApi({
          apiUrl: API_URLS.DELETE_CLIENT_PROFILE_IMAGE("profileImage"),
        });
        if (response?.success) {
          setSuccessPopupMessage("Profile image deleted successfully");
          setShowSuccessPopup(true);
          dispatch(fetchProfileData(user._id));
        } else {
          setErrorPopupMessage(
            response?.message || "Failed to delete profile image",
          );
          setShowErrorPopup(true);
        }
      } catch (error) {
        setErrorPopupMessage(
          error?.message || "Failed to delete profile image",
        );
        setShowErrorPopup(true);
      } finally {
        setSaving(false);
      }
    }
  };

  const handleSave = async () => {
    if (!user?._id) return;

    const formData = new FormData();
    appendJsonSection(
      formData,
      "basicInfo",
      buildBasicInfoPayload(basicInformation),
    );
    appendJsonSection(
      formData,
      "contacts",
      buildContactsFromMyProfile(basicInformation),
    );
    appendProfileFiles(formData, pendingFiles);

    try {
      const result = await dispatch(updateProfileData(formData)).unwrap();
      // toast.success(result?.message || "Profile updated successfully");
      setSuccessPopupMessage("Profile updated successfully");
      setShowSuccessPopup(true);
      setPendingFiles({ profileImageFile: null, bannerImageFile: null });
      setIsEditMode(false);
      dispatch(fetchProfileData(user._id));
    } catch (error) {
      setErrorPopupMessage(
        typeof error === "string" ? error : "Failed to update profile",
      );
      setShowErrorPopup(true);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden px-4 sm:px-6 lg:px-10">
      {/* Header with cover image */}
      <div className="relative w-full bg-gray-100 my-2 rounded-lg overflow-hidden">
        <img
          src={bannerSrc}
          alt="Cover"
          className="w-full h-48 sm:h-56 lg:h-64 block object-cover object-center bg-gray-200"
        />
        <input
          ref={bannerImageInputRef}
          type="file"
          accept="image/jpeg,image/png,image/webp"
          className="hidden"
          onChange={(e) => handleImageSelect("banner", e.target.files?.[0])}
        />
        {isEditMode && (
          <div className="absolute top-4 right-4 z-10">
            <button
              type="button"
              onClick={() => setShowDropdown(!showDropdown)}
              className="bg-white/90 backdrop-blur-sm p-2 rounded-md shadow hover:bg-white transition-colors"
            >
              <Camera size={18} className="text-gray-700" />
            </button>

            {showDropdown && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg overflow-hidden border border-gray-200">
                <button
                  onClick={() => {
                    bannerImageInputRef.current?.click();
                    setShowDropdown(false);
                  }}
                  className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
                >
                  <Upload size={16} /> Upload Photo
                </button>
                {(bannerImagePreview || profile?.bannerImage?.filePath) && (
                  <button
                    onClick={() => {
                      handleDeleteBanner();
                      setShowDropdown(false);
                    }}
                    disabled={saving}
                    className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2 disabled:opacity-50"
                  >
                    <Trash2 size={16} /> Remove Photo
                  </button>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Profile section with proper positioning */}
      <div className="relative px-4 sm:px-6 lg:px-8">
        {/* Profile info positioned over the background */}
        <div className="relative -mt-12 mb-6">
          <div className="flex flex-col sm:flex-row items-start justify-between gap-4 ml-4">
            <div className="flex items-center gap-4">
              <div className="relative">
                <img
                  src={avatarSrc}
                  alt="Profile"
                  className="w-20 h-20 rounded-full border-4 border-white shadow-lg object-cover bg-[#1F5A40]"
                />
                <input
                  ref={profileImageInputRef}
                  type="file"
                  accept="image/jpeg,image/png,image/webp"
                  className="hidden"
                  onChange={(e) =>
                    handleImageSelect("profile", e.target.files?.[0])
                  }
                />
                {isEditMode && (
                  <>
                    <button
                      type="button"
                      onClick={() =>
                        setShowProfileDropdown(!showProfileDropdown)
                      }
                      className="absolute bottom-0 right-0 bg-[#06513D] text-white p-1.5 rounded-full hover:bg-teal-700 transition-colors shadow-md"
                    >
                      <Camera size={14} />
                    </button>

                    {showProfileDropdown && (
                      <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg overflow-hidden border border-gray-200 z-50">
                        <button
                          onClick={() => {
                            profileImageInputRef.current?.click();
                            setShowProfileDropdown(false);
                          }}
                          className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
                        >
                          <Upload size={16} /> Upload Photo
                        </button>
                        {(profileImagePreview ||
                          profile?.profileImage?.filePath) && (
                          <button
                            onClick={() => {
                              handleDeleteProfile();
                              setShowProfileDropdown(false);
                            }}
                            disabled={saving}
                            className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2 disabled:opacity-50"
                          >
                            <Trash2 size={16} /> Remove Photo
                          </button>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
              <div className="mt-10">
                <div className="flex flex-col gap-0">
                  <h1 className="text-2xl font-bold text-gray-900 leading-none">
                    {organizationName || "—"}
                  </h1>
                </div>
                <p className="text-gray-600 mb-1">
                  User ID/{basicInformation.userId}
                </p>
              </div>
            </div>
            {/* <button
              type="button"
              onClick={handleSave}
              disabled={profileUpdateLoading}
              className="mt-8 bg-[#06513D] text-white text-sm px-6 py-2 rounded-md hover:bg-[#054432] disabled:opacity-60"
            >
              {profileUpdateLoading ? "Saving..." : "Save"}
            </button> */}
          </div>
        </div>

        {/* Carbon and Water Footprint Section - Mobile & Desktop: All in row */}
        <div className="mb-6 w-full max-w-5xl mx-auto">
          {/* Mobile: Stack vertically, Desktop: Side by side */}
          <div className="flex flex-col lg:flex-row gap-4">
            {/* Carbon Footprint */}
            {/* <div className="bg-[#06513D] rounded-lg p-3 flex-1"> */}
            {/* Mobile & Desktop: All 3 items in row */}
            {/* <div className="flex items-center justify-between gap-2"> */}
            {/* Icon */}
            {/* <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center shrink-0 bg-white">
                  <CarbonFootprint className="w-5 h-5 sm:w-6 sm:h-6 text-[#06513D]" />
                </div> */}

            {/* Title */}
            {/* <div className="text-white font-semibold text-xs sm:text-sm lg:text-base flex-1 text-center">
                  Total Carbon Footprint
                </div> */}

            {/* Value */}
            {/* <div className="bg-white text-[#06513D] px-2 py-1 sm:px-3 sm:py-2 rounded-lg font-bold text-xs sm:text-sm lg:text-base shadow whitespace-nowrap">
                  5378 <span className="text-xs font-normal">MT CO₂e</span>
                </div> */}
            {/* </div> */}
            {/* </div> */}

            {/* Water Footprint */}
            {/* <div className="bg-[#06513D] rounded-lg p-3 flex-1"> */}
            {/* Mobile & Desktop: All 3 items in row */}
            {/* <div className="flex items-center justify-between gap-2"> */}
            {/* Icon */}
            {/* <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center shrink-0 bg-white">
                  <WaterFootprint className="w-5 h-5 sm:w-6 sm:h-6 text-[#06513D]" />
                </div> */}

            {/* Title */}
            {/* <div className="text-white font-semibold text-xs sm:text-sm lg:text-base flex-1 text-center">
                  Total Water Footprint
                </div> */}

            {/* Value */}
            {/* <div className="bg-white text-[#06513D] px-2 py-1 sm:px-3 sm:py-2 rounded-lg font-bold text-xs sm:text-sm lg:text-base shadow whitespace-nowrap">
                  4582 <span className="text-xs font-normal">MT CO₂e</span>
                </div> */}
            {/* </div> */}
            {/* </div> */}
          </div>
        </div>

        {/* Combined Basic Information and Contact Details */}
        <div className="bg-white rounded-xl shadow-md border border-[#3BA2B959] mb-6">
          <div className="p-4 sm:p-6">
            <fieldset
              disabled={!isEditMode}
              className="border-none p-0 m-0 disabled:opacity-80"
            >
              {/* Basic Information Section */}
              <div className="mb-8">
                <h2 className="text-lg font-semibold text-[#06513D] mb-4">
                  Basic Information
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={basicInformation.name}
                      onChange={handleChange}
                      className="w-full border-b border-gray-300 px-0 py-2 focus:outline-none focus:border-[#06513D]"
                      placeholder="Enter your name"
                    />
                  </div>
                  {/* <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Username
                  </label>
                  <input
                    type="text"
                    name="username"
                    value={basicInformation.username}
                    onChange={handleChange}
                    className="w-full border-b border-gray-300 px-0 py-2 focus:outline-none focus:border-[#06513D]"
                    placeholder="Enter username"
                  />
                </div> */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Email / Username
                    </label>
                    <input
                      type="email"
                      value={loginEmail}
                      readOnly
                      className="w-full border-b border-gray-300 px-0 py-2 bg-gray-50 text-gray-600 cursor-not-allowed"
                      placeholder="Login email"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      User ID
                    </label>
                    <input
                      type="text"
                      name="userId"
                      value={basicInformation.userId}
                      readOnly
                      className="w-full border-b border-gray-300 px-0 py-2 bg-gray-50 text-gray-600 cursor-not-allowed"
                      placeholder="User ID"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Role
                    </label>
                    <input
                      type="text"
                      name="role"
                      value={role}
                      readOnly
                      className="w-full border-b border-gray-300 px-0 py-2 bg-gray-50 text-gray-600 cursor-not-allowed"
                      placeholder="Role"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Location
                    </label>
                    <select
                      name="location"
                      value={basicInformation.location}
                      onChange={handleChange}
                      className="w-full border-b border-gray-300 px-0 py-2 focus:outline-none focus:border-[#06513D]"
                    >
                      <option value="">Select a country</option>
                      {basicInformation.location &&
                        !countries.includes(basicInformation.location) && (
                          <option value={basicInformation.location}>
                            {basicInformation.location}
                          </option>
                        )}
                      {countries.map((country, index) => (
                        <option key={index} value={country}>
                          {country}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* Contact Details Section */}
              <div>
                <h2 className="text-lg font-semibold text-[#06513D] mb-4">
                  Contact Details
                </h2>

                <div className="space-y-6">
                  {/* Primary Contact Row */}
                  <div className="flex flex-col sm:flex-row justify-between gap-4 sm:gap-5 items-start sm:items-center">
                    <div className="w-full sm:flex-1">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        1. Contact Number
                      </label>

                      <input
                        type="tel"
                        name="contactNumber_1"
                        value={basicInformation.contactNumber_1}
                        onChange={handleChange}
                        className="w-full border-b border-gray-300 px-0 py-2 focus:outline-none focus:border-[#06513D]"
                        placeholder="Enter contact number"
                      />
                    </div>
                    <div className="w-full sm:flex-1">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Email ID
                      </label>
                      <input
                        type="email"
                        name="emailId_1"
                        value={basicInformation.emailId_1}
                        onChange={handleChange}
                        className="w-full border-b border-gray-300 px-0 py-2 focus:outline-none focus:border-[#06513D]"
                        placeholder="Enter email address"
                      />
                    </div>
                    <div className="flex items-center gap-2 pt-2 sm:pt-0">
                      <input
                        type="radio"
                        id="primary_1"
                        name="primaryContact"
                        onChange={() => handlePrimarySelection("contact_1")}
                        checked={
                          basicInformation.primaryContactNumber ===
                          basicInformation.contactNumber_1
                        }
                        className="w-4 h-4 text-[#06513D] focus:ring-[#06513D]"
                      />
                      <label
                        htmlFor="primary_1"
                        className="text-sm text-gray-700"
                      >
                        Make it Primary
                      </label>
                    </div>
                  </div>

                  {/* Secondary Contact Row */}
                  <div className="flex flex-col sm:flex-row justify-between gap-4 sm:gap-5 items-start sm:items-center">
                    <div className="w-full sm:flex-1">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        2. Contact Number
                      </label>
                      <input
                        type="tel"
                        name="contactNumber_2"
                        value={basicInformation.contactNumber_2}
                        onChange={handleChange}
                        className="w-full border-b border-gray-300 px-0 py-2 focus:outline-none focus:border-[#06513D]"
                        placeholder="Enter contact number"
                      />
                    </div>
                    <div className="w-full sm:flex-1">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Email ID
                      </label>
                      <input
                        type="email"
                        name="emailId_2"
                        value={basicInformation.emailId_2}
                        onChange={handleChange}
                        className="w-full border-b border-gray-300 px-0 py-2 focus:outline-none focus:border-[#06513D]"
                        placeholder="Enter email address"
                      />
                    </div>
                    <div className="flex items-center gap-2 pt-2 sm:pt-0">
                      <input
                        type="radio"
                        id="primary_2"
                        name="primaryContact"
                        onChange={() => handlePrimarySelection("contact_2")}
                        checked={
                          basicInformation.primaryContactNumber ===
                          basicInformation.contactNumber_2
                        }
                        className="w-4 h-4 text-[#06513D] focus:ring-[#06513D]"
                      />
                      <label
                        htmlFor="primary_2"
                        className="text-sm text-gray-700"
                      >
                        Make it Primary
                      </label>
                    </div>
                  </div>
                </div>

                {/* Description */}
                <div className="mt-6">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Description
                  </label>
                  <textarea
                    name="description"
                    value={basicInformation.description}
                    onChange={handleChange}
                    rows={4}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#06513D] focus:border-transparent resize-none"
                    placeholder="Add a description..."
                  />
                </div>

                {/* Add Contact Details Button */}
                {/* <button className="w-full mt-6 bg-[#C8D9D4] text-[#06513D] py-2 px-4 rounded-md hover:bg-[#B8C9C4] transition-colors flex items-center justify-center gap-2 font-semibold">
                <Plus size={16} />
                Add Contact Details
              </button> */}

                {/* Primary Contact Display */}
                {/* {basicInformation.primaryContactNumber && (
                <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded-lg">
                  <p className="text-green-700 font-semibold">
                    Primary Contact: {basicInformation.primaryContactNumber} (
                    {basicInformation.primaryEmailId})
                  </p>
                </div>
              )} */}
              </div>
            </fieldset>
          </div>
        </div>

        <div className="text-center mb-6 flex justify-center gap-4">
          {!isEditMode ? (
            <button
              type="button"
              onClick={() => setIsEditMode(true)}
              className="bg-[#054432] text-white text-sm px-10 py-3 rounded-md hover:bg-[#387464]"
            >
              Edit Profile
            </button>
          ) : (
            <>
              <button
                type="button"
                onClick={() => {
                  setIsEditMode(false);
                  if (user?._id) {
                    dispatch(fetchProfileData(user._id));
                  }
                }}
                className="bg-[#E6EDEB] text-[#06513D] text-sm px-10 py-3 rounded-md hover:bg-[#F8F8F8] border "
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSave}
                disabled={profileUpdateLoading}
                className="bg-[#06513D] text-white text-sm px-10 py-3 rounded-md hover:bg-[#387464] disabled:opacity-60"
              >
                {profileUpdateLoading ? "Saving..." : "Save Changes"}
              </button>
            </>
          )}
        </div>
        {showSuccessPopup && (
          <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center pointer-events-none">
            <PopupCard
              type="success"
              title="Success"
              message={successPopupMessage || "Profile updated successfully"}
              // onCancel={() => setShowSuccessPopup(false)}
            />
          </div>
        )}
        {showErrorPopup && (
          <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
            <PopupCard
              type="error"
              title="Error"
              message={errorPopupMessage}
              onCancel={() => setShowErrorPopup(false)}
              cancelText="OK"
            />
          </div>
        )}
      </div>
    </div>
  );
}
